import styled from "styled-components";

export const SwitchContainer = styled.span<{ $corProjeto?: boolean }>`
  .form-check-input {
    cursor: pointer;
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e");

    &:focus,
    &:focus-visible {
      box-shadow: none;
      --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e");
    }

    &:checked {
      background-color: ${({ theme, $corProjeto }) =>
        $corProjeto ? theme.colors.project.main : "#28a745"};
      border-color: ${({ theme, $corProjeto }) =>
        $corProjeto ? theme.colors.project.main : "#28a745"};
    }

    &:not(:checked) {
      background-color: #cccccc;
      border-color: #cccccc;
    }
  }
`;
